export const CLASSIC_STORY_POINT_TEST_ID =
	'issue-field-classic-story-point.ui.issue-field-classic-story-point';
